import {Injectable} from '@angular/core';
import * as _ from "lodash";
import {LogCat, LogManager} from "../../../../common/log";
import { lookup } from 'dns';

export interface IPathEvaluation {
	getter: () => any;
	setter: (val) => void;
	path: string;
}

@Injectable({ providedIn: 'root' })
  export class PathEvaluator {
	private pathCache = new Map<string, string[]>();

	/**
	 * @deprecated
	 */
	public evaluate(path, obj: any): IPathEvaluation {
		if (!path) {
			return {
				path,
				getter: () => obj,
				setter: val => { }
			};
		}
		let parts = path.toString().split('.');
		let lastKey = parts.splice(parts.length - 1)[0];
		return {
			path,
			getter: () => parts.reduce((o, key) => o[key], obj)[lastKey],
			setter: val => { parts.reduce((o, key) => o[key], obj)[lastKey] = val; }
		};
	}

	public get(obj: any, path: string): any {
		let props = this.pathCache.get(path);

		if (props === undefined) {
			props = this.toPath(path);
			this.pathCache.set(path, props);
		}

		return props.reduce((o, key) => o ? o[key] : undefined, obj);
	}

	public getLookupRow(obj:any, path:string) {
		let pathParts = this.toPath(path);
		let propName = pathParts[pathParts.length - 1];
		
		pathParts[pathParts.length - 1] = 'FKLookupRows';
		pathParts.push(propName);
		let fKLookupRowsPath = pathParts.join('.');

		return this.get(obj, fKLookupRowsPath);
	}

	public exists(obj: any, path: string) : boolean {
		let props = this.toPath(path);
		return !!props.reduce((o, key, i) => {
			if (i === props.length - 1) {
				return (o !== undefined);
			}

			return (o ? o[key] : undefined);
		}, obj);
	}

	/**
	 * @param obj - the object to read from
	 * @param logicPath - for example: 'visit[visitKey=123].orders[orderKey=456].requestedProcedure'
	 * @returns the value of this path if exists, undefined otherwise.
	 */
	public logicGet(obj: any, logicPath: string): any {
		let props = this.toPath(logicPath);
		return props.reduce((o, key) => {
			if (!o) {
				return undefined;
			}
			if (key.includes('=')) {
				let [idProp, idVal] = key.split('=');
										/* tslint:disable */
				return o.find(item => ""+item[idProp] == idVal);
			}							/* tslint:enable */
			return o[key];
		}, obj);
	}

	public toPath(path : string) : string[] {
		return _.toPath(path).filter(x => !_.isEmpty(x));
	}
    /*************************************************************
	 * @param path - the path to normalize
	 * This method will replace all '[' and ']' with '.'
	 * Example:
	 *    Input- visit[0].orders[0].requestedProcedure[0].sps
     *    Output- visit.0.orders.0.requestedProcedure.0.sps
	 *************************************************************/
	public normalize(path: string) : string {
		if (!path.includes('[')) {
			return path;
		}

		let newPath = path.replace(/\[/g, '.').replace(/\]/g, '');

		if (newPath.includes('..')) {
			LogManager.error(LogCat.Forms.Load,"Path normalize result in invalid path (old : new) - " +
				path + " : " + newPath);

			newPath = newPath.replace(/\.\./g, '.');
		}

		return newPath;
	}
    /****************************************************************
	 * @param path - the path to convert
	 * This method will replace all '.integer.'  with '[integer].'
	 * Examples:
	 *   Input- visit.0.orders.0.requestedProcedure.0.sps
	 *   Output- visit[0].orders[0].requestedProcedure[0].sps
	 *   Input- visit.0.orders[1].requestedProcedure.2.sps
	 *   Output- visit[0].orders[1].requestedProcedure[2].sps
	 *   See path.evaluator.spec.ts for more examples
	 ***************************************************************/
    public  convertToIndexers(path:string) {
		return path.replace(/(\.\d+)(?!\])/g, match => `[${match.slice(1)}]`);
	}

	public normalizeWildcardPath(path: string): string {
		return path.replace('[*]', '[0]');
	}

	public convertLastIndexToWildcardPath(path: string): string {

		if (path.includes('[*]')){
			return path;
		}

		let lastPathIndex = path.lastIndexOf('[0]');
		if (lastPathIndex < 0) {
			return path;
		}
		return path.substr(0, lastPathIndex) + path.substr(lastPathIndex).replace('[0]', '[*]');

	}

	public convertToContextColumnPath(columnPath: string) {
		let columnNameIndex =columnPath.lastIndexOf('.');
		if (columnNameIndex > 0) {
			return `${columnPath.substr(0, columnNameIndex)}[*]${columnPath.substr(columnNameIndex)}`;
		}

		return columnPath;
	}

	public convertFromContextColumnPath(contextColumnPath: string) {
		return contextColumnPath.replace('[*]', '');
	}


	
	public getLookupColumnFullPath(columnFullPath: string, lookupColumnName: string) {
		let pathParts =	columnFullPath.split('.');
		let lookupKey =  pathParts.pop();
		pathParts.push('FKLookupRows', lookupKey, lookupColumnName);

		return pathParts.join('.');
	}
}
